import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation, OnInit } from '@angular/core';
import { DsButtonV2Component } from '@customdesignsystem';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-boton-volver',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './boton-volver.component.html',
    styleUrls: ['./boton-volver.component.scss'],
    standalone: true,
    imports: [CommonModule, IonicModule, DsButtonV2Component]
})
export class BotonVolverComponent implements OnInit {
    @Input() texto: string = 'Volver';
    @Input() nombreIcono: string = 'arrow-back-outline';
    @Output() clickVolver: EventEmitter<void> = new EventEmitter<void>();    
    textoBtnVolver: string = 'Volver';
    ngOnInit(): void {
        if(window.innerWidth <= 839) {
            this.textoBtnVolver = 'Volver al paso anterior';
        }

    }

    alHacerClicVolver(): void {
        this.clickVolver.emit();
    }
}
